/* eslint-disable */
/*! modernizr 3.3.1 (Custom Build) | MIT *
 * https://modernizr.com/download/?-flexbox-rgba-textshadow-setclasses !*/
!(function(e, n, t) {
  function r(e, n) {
    return typeof e === n;
  }
  function o() {
    var e, n, t, o, s, i, a;
    for (var l in x)
      if (x.hasOwnProperty(l)) {
        if (
          ((e = []),
          (n = x[l]),
          n.name &&
            (e.push(n.name.toLowerCase()),
            n.options && n.options.aliases && n.options.aliases.length))
        )
          for (t = 0; t < n.options.aliases.length; t++)
            e.push(n.options.aliases[t].toLowerCase());
        for (o = r(n.fn, "function") ? n.fn() : n.fn, s = 0; s < e.length; s++)
          (i = e[s]),
            (a = i.split(".")),
            1 === a.length
              ? (Modernizr[a[0]] = o)
              : (!Modernizr[a[0]] ||
                  Modernizr[a[0]] instanceof Boolean ||
                  (Modernizr[a[0]] = new Boolean(Modernizr[a[0]])),
                (Modernizr[a[0]][a[1]] = o)),
            y.push((o ? "" : "no-") + a.join("-"));
      }
  }
  function s(e) {
    var n = w.className,
      t = Modernizr._config.classPrefix || "";
    if ((b && (n = n.baseVal), Modernizr._config.enableJSClass)) {
      var r = new RegExp("(^|\\s)" + t + "no-js(\\s|$)");
      n = n.replace(r, "$1" + t + "js$2");
    }
    Modernizr._config.enableClasses &&
      ((n += " " + t + e.join(" " + t)),
      b ? (w.className.baseVal = n) : (w.className = n));
  }
  function i() {
    return "function" != typeof n.createElement
      ? n.createElement(arguments[0])
      : b
        ? n.createElementNS.call(n, "http://www.w3.org/2000/svg", arguments[0])
        : n.createElement.apply(n, arguments);
  }
  function a(e, n) {
    return !!~("" + e).indexOf(n);
  }
  function l(e) {
    return e
      .replace(/([a-z])-([a-z])/g, function(e, n, t) {
        return n + t.toUpperCase();
      })
      .replace(/^-/, "");
  }
  function f(e) {
    return e
      .replace(/([A-Z])/g, function(e, n) {
        return "-" + n.toLowerCase();
      })
      .replace(/^ms-/, "-ms-");
  }
  function u() {
    var e = n.body;
    return e || ((e = i(b ? "svg" : "body")), (e.fake = !0)), e;
  }
  function d(e, t, r, o) {
    var s,
      a,
      l,
      f,
      d = "modernizr",
      c = i("div"),
      p = u();
    if (parseInt(r, 10))
      for (; r--; )
        (l = i("div")), (l.id = o ? o[r] : d + (r + 1)), c.appendChild(l);
    return (
      (s = i("style")),
      (s.type = "text/css"),
      (s.id = "s" + d),
      (p.fake ? p : c).appendChild(s),
      p.appendChild(c),
      s.styleSheet
        ? (s.styleSheet.cssText = e)
        : s.appendChild(n.createTextNode(e)),
      (c.id = d),
      p.fake &&
        ((p.style.background = ""),
        (p.style.overflow = "hidden"),
        (f = w.style.overflow),
        (w.style.overflow = "hidden"),
        w.appendChild(p)),
      (a = t(c, e)),
      p.fake
        ? (p.parentNode.removeChild(p), (w.style.overflow = f), w.offsetHeight)
        : c.parentNode.removeChild(c),
      !!a
    );
  }
  function c(n, r) {
    var o = n.length;
    if ("CSS" in e && "supports" in e.CSS) {
      for (; o--; ) if (e.CSS.supports(f(n[o]), r)) return !0;
      return !1;
    }
    if ("CSSSupportsRule" in e) {
      for (var s = []; o--; ) s.push("(" + f(n[o]) + ":" + r + ")");
      return (
        (s = s.join(" or ")),
        d(
          "@supports (" + s + ") { #modernizr { position: absolute; } }",
          function(e) {
            return "absolute" == getComputedStyle(e, null).position;
          }
        )
      );
    }
    return t;
  }
  function p(e, n, o, s) {
    function f() {
      d && (delete S.style, delete S.modElem);
    }
    if (((s = r(s, "undefined") ? !1 : s), !r(o, "undefined"))) {
      var u = c(e, o);
      if (!r(u, "undefined")) return u;
    }
    for (
      var d, p, m, h, v, g = ["modernizr", "tspan", "samp"];
      !S.style && g.length;

    )
      (d = !0), (S.modElem = i(g.shift())), (S.style = S.modElem.style);
    for (m = e.length, p = 0; m > p; p++)
      if (
        ((h = e[p]),
        (v = S.style[h]),
        a(h, "-") && (h = l(h)),
        S.style[h] !== t)
      ) {
        if (s || r(o, "undefined")) return f(), "pfx" == n ? h : !0;
        try {
          S.style[h] = o;
        } catch (y) {}
        if (S.style[h] != v) return f(), "pfx" == n ? h : !0;
      }
    return f(), !1;
  }
  function m(e, n) {
    return function() {
      return e.apply(n, arguments);
    };
  }
  function h(e, n, t) {
    var o;
    for (var s in e)
      if (e[s] in n)
        return t === !1
          ? e[s]
          : ((o = n[e[s]]), r(o, "function") ? m(o, t || n) : o);
    return !1;
  }
  function v(e, n, t, o, s) {
    var i = e.charAt(0).toUpperCase() + e.slice(1),
      a = (e + " " + E.join(i + " ") + i).split(" ");
    return r(n, "string") || r(n, "undefined")
      ? p(a, n, o, s)
      : ((a = (e + " " + z.join(i + " ") + i).split(" ")), h(a, n, t));
  }
  function g(e, n, r) {
    return v(e, t, t, n, r);
  }
  var y = [],
    x = [],
    C = {
      _version: "3.3.1",
      _config: {
        classPrefix: "",
        enableClasses: !0,
        enableJSClass: !0,
        usePrefixes: !0
      },
      _q: [],
      on: function(e, n) {
        var t = this;
        setTimeout(function() {
          n(t[e]);
        }, 0);
      },
      addTest: function(e, n, t) {
        x.push({ name: e, fn: n, options: t });
      },
      addAsyncTest: function(e) {
        x.push({ name: null, fn: e });
      }
    },
    Modernizr = function() {};
  (Modernizr.prototype = C), (Modernizr = new Modernizr());
  var w = n.documentElement,
    b = "svg" === w.nodeName.toLowerCase();
  Modernizr.addTest("rgba", function() {
    var e = i("a").style;
    return (
      (e.cssText = "background-color:rgba(150,255,150,.5)"),
      ("" + e.backgroundColor).indexOf("rgba") > -1
    );
  });
  var _ = { elem: i("modernizr") };
  Modernizr._q.push(function() {
    delete _.elem;
  });
  var S = { style: _.elem.style };
  Modernizr._q.unshift(function() {
    delete S.style;
  });
  var P = (C.testProp = function(e, n, r) {
    return p([e], t, n, r);
  });
  Modernizr.addTest("textshadow", P("textShadow", "1px 1px"));
  var T = "Moz O ms Webkit",
    E = C._config.usePrefixes ? T.split(" ") : [];
  C._cssomPrefixes = E;
  var z = C._config.usePrefixes ? T.toLowerCase().split(" ") : [];
  (C._domPrefixes = z),
    (C.testAllProps = v),
    (C.testAllProps = g),
    Modernizr.addTest("flexbox", g("flexBasis", "1px", !0)),
    o(),
    s(y),
    delete C.addTest,
    delete C.addAsyncTest;
  for (var N = 0; N < Modernizr._q.length; N++) Modernizr._q[N]();
  e.Modernizr = Modernizr;
})(window, document);
